import React, { useEffect } from 'react'
import AboutHero from './AboutHero'
import Service from './Service'
import Footer from '../Footer/Footer'
import AOS from 'aos'
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    AOS.init({
      easing: 'ease-in-out',
      duration: 700,
    });
  }, [])
  return (
    <div className='flex flex-col bg-[#06000A] overflow-hidden'>
      <AboutHero />
      <Service />
      <Footer />
    </div>
  )
}

export default About